import type {Result, UseCase} from 'framework';
import type {BodyMetricId} from '../../domain/body-metric';
import type {BodyMeasurementsError} from '../../domain/errors';
import type {BodyMeasurementsRepository} from '../ports/body-measurements.repository';

export type DeleteBodyMetricInput = {
  readonly metricId: BodyMetricId;
};

export class DeleteBodyMetric implements UseCase<[DeleteBodyMetricInput], void> {
  constructor(private readonly repository: BodyMeasurementsRepository) {}

  execute(input: DeleteBodyMetricInput): Promise<Result<void, BodyMeasurementsError>> {
    return this.repository.deleteMetric(input.metricId);
  }
}
